module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Image8680.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-9",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_vm._v("BIRDIE B.’S SILVER SCISSORS")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter-subtitle",
    attrs: {
      "id": "_idParaDest-10",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "all-caps"
  }, [_vm._v("Sharon Huey")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I stood on the rocker of Mother’s chair and looked over her shoulder as she did some hand sewing. I wanted to be outside, but a recent bout with pneumonia kept me tied to her apron strings. Mother showed the most compassion when I was sick, her tenderness boundless during those times. The healthier I became, the more the disciplinarian emerged in her. She wanted me off the rockers of her chair.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sharon, bring me my little scissors.” I could hear the edgy pitch in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Which ones are they?” I asked, hopping off the rocker. The chair lunged forward.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The little scissors with the piece of red material on the handle,” she heaved a sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I found the scissors on the sewing machine and carried them to her bedroom where she sat in a chair listening to the TV but paying more attention to her needle and thread. She brought the thread to her front teeth and bit it off close to the material. The stringy leftovers she clipped away with the silver scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why did you have to have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("those")]), _vm._v(" scissors?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They are the only ones that will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But why?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sharon, you make me tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I looked off into space hoping to let myself drift in a day dream when she said, “They belonged to my mama.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They did?” I couldn’t believe she ever had a mother. “Your mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, your grandmother. She was an excellent seamstress. She made all my clothes. Once when I was in college, she made me a brown and yellow dress that was a perfect copy of the latest fashion. A girl in my dorm asked if she could borrow it. I didn’t even share clothes with my sisters, but I let her wear the dress. The Dean of Women called me to her office and got on to me for loaning that darling dress that my mama had put so much work into. I got the dress back and never let anyone else wear my clothes again.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did my grandmother know me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, she died before you were born.” Mother trimmed and snipped at wayward threads as she talked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“These little scissors belonged to her. See this piece of fabric tied to the handle?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is from the last dress she ever made before she died.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh,” I rubbed the frayed red cotton between my thumb and index finger. “Soft.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She started me out sewing pillow cases with a simple over and under straight stitch. Soon, she had me making underwear and bed clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Underwear? You made underwear?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, I did. Eventually, she taught me to sew on the machine. My baby brother, Bruce, would crawl under the sewing machine in the afternoon and take a nap. I guess the sounds of Mama and me talking combined with the machine going just put him right to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is he a grown up man, now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, you know him—Uncle Bruce.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s funny that he slept under the sewing machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We all worked in the yard, the kitchen, or washing. Nobody was going to stop and put the baby down for a nap. He just slept wherever he was comfortable. He liked to get under Mama’s machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did your sewing machine that you have now, belong to your mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, after Mama died, your daddy and I brought her sewing machine home with us. Mama’s machine was brand new, only a few months old. I was the only one of the girls interested in sewing, so I got her machine. When we got it home and set up, your daddy and I could not thread the bobbin. I wanted to use the machine so badly, but after weeks and weeks of trying, we still could not figure out how to make it work. It sat idle. Finally, I just gave up on sewing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mother paused and concentrated on her own stitches. I sat on the floor to get a better look at her face. Were her eyes misting behind her thick glasses?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So what happened?” I prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I probably shouldn’t tell you this. It will make you believe in ghosts or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, I won’t. Please tell me.” Mother considered whether to tell me the story or not. “Please,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, all right. One night about three weeks after she had died, Mama came to me in a dream.” Mother looked and sounded excited. “She stood right in front of me and said: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Birdie, this is how you do it.”")]), _vm._v(" She held the bobbin in one hand and the case in the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mother’s voice took on a mystical quality, soft and full of awe. She blinked away several tears but continued.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mama clicked the bobbin into its case, pulled and tightened the thread just so with her fingers, and dropped the bobbin in the machine. She showed me with her own hands. When I woke up in the morning, I felt wonderful because I had been with Mama. I went straight to the machine and threaded the bobbin. That was in 1940 before you were born. I still miss her.” Mother wiped at her eyes. “Sharon, get me a Kleenex.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I pulled a Kleenex out of the box on the dresser and handed it to her. She dabbed at her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mama used to say, ‘Work is our salvation.’”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What did she mean by that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She meant if a person is busy, they don’t have to dwell on things so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What things?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Back then, children died of pneumonia, diphtheria, and typhoid. We didn’t have booster shots.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Died?” I had only heard of one child dying, and she had fallen from a high tree limb.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, back then life was hard. Only four of Mama’s nine children lived to be adults.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I quieted thinking about my recent run-in with pneumonia, while Mother pushed forward quickly with her story.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I asked Mama once which one was the hardest to lose. That was after my older brother Orrin died. He was only forty years old when he died of cancer.” Mother shook her head. “Mama said, ‘Well, the longer you have a child, of course, the more you love it, but the one I grieve over most is the baby.’”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mother circled the thread around her finger and pulled until a knot appeared. Using the scissors she cut a dangling piece of thread close to the loop. She continued the story.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Papa went to L.S.U. in the summer of 1912 to start his master’s degree. The board of education had said that all principals had to have their masters, or they could not stay in the job. Papa rode a horse to Baton Rouge, which took several weeks. When the ten-month old baby got very sick, Mama had no way to reach Papa.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Weren’t there any phones?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, but not along the way. Papa stayed in farmers’ barns or camped out in the open while he traveled. Mama sent a telegram to L.S.U. By the time he received the message that there was trouble at home, the baby had died and been buried. He grieved so much over the loss of the baby and not being at home when Mama needed him that he told the school board he didn’t want to be principal anymore. That is how he became the postmaster.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mother bit off another thread and sliced it close to the edge of the material with the silver scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What did the baby die of?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know—probably pneumonia or flu. A lot of babies died back then.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh.” I thought about that for a minute. “Would that baby have been your brother or sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My baby sister, yes. Here, put my little scissors back. Be careful. They are sharp.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I carried the little scissors with the red material still dangling from the handle back to the sewing box. They felt like nothing in my hand, but in my heart they placed me back in a time where I saw and heard the secrets of a strong, brave woman, a grandmother I never knew.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Just as my mother and grandmother sewed using the little silver scissors, so do I. The faded red cloth, a remnant of the last dress my grandmother sewed over seventy years ago, remains tied to the handle of my little scissors even as I use them today, binding me spiritually to place, people, tradition, and stories that have to be told.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As an English and Drama teacher, Sharon Huey sponsored literary magazines, directed plays, and coached individual speaking events and mock trials before retiring in front of the computer screen with a blank mind. She is looking for representation for her first novel, ")]), _c('em', {
    staticClass: "italic CharOverride-7"
  }, [_vm._v("Listen to the Lambs")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", and is working on a second novel")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a633783","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectKeepsake65.vue
// module id = 81
// module chunks = 0